var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.308,
    height: 20.938,
    viewBox: "0 0 18.308 20.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-account",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15341",
    "data-name": "Grupo 15341",
    transform: "translate(-255.211 -337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14527",
    "data-name": "Caminho 14527",
    d: "M32.472,18.965H29.784a1.609,1.609,0,0,1-1.607-1.607V3.214a1.609,1.609,0,0,1,1.607-1.607h11.88a1.609,1.609,0,0,1,1.607,1.607V6.156a.8.8,0,1,0,1.607,0V3.214A3.218,3.218,0,0,0,41.664,0H29.784A3.218,3.218,0,0,0,26.57,3.214V17.357a3.218,3.218,0,0,0,3.214,3.214h2.688a.8.8,0,0,0,0-1.607Z",
    transform: "translate(228.641 337)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15340",
    "data-name": "Grupo 15340",
    transform: "translate(-41.311 -65.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14528",
    "data-name": "Caminho 14528",
    d: "M27.523,28.936H21.376A2.306,2.306,0,0,1,19.07,26.63V18.176a2.306,2.306,0,0,1,2.306-2.306h6.147a2.306,2.306,0,0,1,2.306,2.306V26.63A2.306,2.306,0,0,1,27.523,28.936ZM21.376,17.405a.771.771,0,0,0-.771.771V26.63a.771.771,0,0,0,.771.771h6.147a.771.771,0,0,0,.771-.771V18.176a.771.771,0,0,0-.771-.771Z",
    transform: "translate(285 395)",
    fill: "#898d92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14529",
    "data-name": "Caminho 14529",
    d: "M23.33,20.13h4.612v1.535H23.33Z",
    transform: "translate(283.81 393.81)",
    fill: "#898d92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14530",
    "data-name": "Caminho 14530",
    d: "M23.33,24.4h1.535v1.535H23.33Z",
    transform: "translate(283.81 392.617)",
    fill: "#898d92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14531",
    "data-name": "Caminho 14531",
    d: "M27.6,24.4h1.535v1.535H27.6Z",
    transform: "translate(282.617 392.617)",
    fill: "#898d92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14532",
    "data-name": "Caminho 14532",
    d: "M23.33,27.6h1.535v1.535H23.33Z",
    transform: "translate(283.81 391.723)",
    fill: "#898d92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14533",
    "data-name": "Caminho 14533",
    d: "M27.6,27.6h1.535v1.535H27.6Z",
    transform: "translate(282.617 391.723)",
    fill: "#898d92"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAccount);
export default __webpack_public_path__ + "static/media/ico-account.6c80cfbedbfd8f1b4145e7cb6ab3656a.svg";
export { ForwardRef as ReactComponent };